import { createElement } from "@/utils/create-elem.js";
import { getLS } from "@/utils/local-storage.js";
import "@/styles/components/modal.scss";
/**
 * Creates a select dropdown with options.
 * @param {Object} params - The parameters for creating the select element.
 * @param {string} params.text
 * @param {string} params.id
 * @param {string[]} params.classes - Optional array of CSS class names.
 * @param {HTMLElement=} params.parent - Optional parent element to append the select.
 * @param {Function} onClick
 * @returns {HTMLSelectElement} - The created select element.
 */
export function modal(parent) {
  const overlay = createElement({
    tag: "div",
    classes: ["modal-overlay"],
    parent: parent,
  });
  createElement({
    tag: "div",
    id: "modal",
    text: "Great! You have solved the nonogram!",
    classes: ["modal"],
    parent: overlay,
  });

  if (getLS("sound") === "on") {
    const winSound = new Audio("/sounds/win.mp3");
    winSound.currentTime = 0;
    winSound.play();
  }

  overlay.addEventListener("click", (e) => {
    if (e.target) {
      overlay.remove();
    }
  });

  return overlay;
}
